import { React, models, kea, history, resources, selectores, componentToRx, Route } from "app/main/std";

export class NoAutorizado extends React.PureComponent {
    render() {
        const props = this.props;
        return (
            <div>
                <kea.Title titulo="No autorizado" />
                Su usuario no tiene permisos de ver este módulo
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/inicio/unauth.tsx